import React, { Component } from 'react';
import './LockedMessage.css';

import Title from '../ui/Title.js';
import BodyText from '../ui/BodyText.js';
import Button from '../ui/Button.js';

class LockedMessage extends Component {

  render() {

    return (
      <div className = "LockedMessage qtq-modal-content">
        <Title
          label = {this.props.translationService.get('lockedmessage.title')}
          onClose = {this.props.onClose}
        />
        <BodyText
          text = {this.props.translationService.get('lockedmessage.bodytext')}
        />
        <Button
          label = {this.props.translationService.get('actions.close')}
          onClick = {this.props.onButtonClick}
        />
      </div>
    );

  }

}

export default LockedMessage;



// WEBPACK FOOTER //
// ./src/comps/LockedMessage.js